module.exports = __webpack_public_path__ + "static/portugal-2020-white-xxl-12dade4e1185a336591109407152349b.svg";